import has from 'lodash/has.js';
import get from 'lodash/get.js';
import { formatFullName, nl2br } from '@/utils/index.js';
import i18n from '../plugins/vue-i18n.js';

export default {
    methods: {
        // Resets component to its default state.
        $reset({ redirectTo } = {}) {
            Object.assign(this.$data, this.$options.data.apply(this));

            if (redirectTo) {
                this.$router.push(redirectTo);
            }
        },

        /*
         * String validators
         */
        empty(value) {
            return empty(value);
        },

        find(haystack, needle, caseSensitive = false) {
            if (empty(haystack)) {
                return false;
            }

            haystack = (caseSensitive ? haystack : haystack.toLowerCase()).trim();
            needle = (caseSensitive ? needle : needle.toLowerCase()).trim();

            return haystack.indexOf(needle) !== -1;
        },


        /*
         * String formatters
         */
        nl2br(value) {
            return nl2br(value);
        },

        formatFullName(object) {
            return formatFullName(object);
        },

        formatPhone(phone, country = false) {
            if (empty(phone)) return '';

            phone = phone.toString().replace(/\D/g, '');

            if (!phone.startsWith('1')) {
                phone = `1${phone}`;
            }

            if (country) {
                return phone.replace(new RegExp(/(\d{1})(\d{3})(\d{3})(\d{4})/, 'g'), '+$1 $2 $3-$4');
            }

            return phone.replace(new RegExp(/(\d{1})(\d{3})(\d{3})(\d{4})/, 'g'), '$2 $3-$4');
        },

        getPostalCodeOrZip(account) {
            if (!account.postal_code) {
                return '';
            }

            if (account.country === 'US') {
                return account.postal_code;
            }

            return account.postal_code.toUpperCase()
                .replace(/\W/g, '')
                .replace(/(...)/, '$1 ');
        },

        getProvinceOrStateString(account, locale) {
            if (!account.country || !account.province) {
                return '';
            }

            const countrySubpartsType = account.country === 'CA' ? 'provinces' : 'states';
            const subpartIdentifier = account.province.toLowerCase();

            return i18n.t(`global.${countrySubpartsType}.${subpartIdentifier}`, locale);
        },

        getCountryString(countryCode, locale) {
            if (!countryCode) {
                return '';
            }

            return i18n.t(`global.countries.${countryCode.toLowerCase()}`, locale);
        },

        formatLocale(locale) {
            if (!locale) {
                return '';
            }

            return locale == 'fr' ? 'Français' : 'English';
        },

        formatDateTime(dateTime) {
            const momentDate = moment(dateTime);

            if (!momentDate.isValid() || empty(dateTime)) {
                return '';
            }

            if (this.$i18n.locale == 'en') {
                return momentDate.format('D MMM YYYY hh:mm A');
            }

            return momentDate.format('D MMM YYYY HH:mm');
        },

        formatDate(date, locale = null) {
            const momentDate = !empty(locale) ? moment(date).locale(locale) : moment(date);

            if (!momentDate.isValid() || empty(date)) {
                return '';
            }

            return momentDate.format('D MMM YYYY');
        },

        formatTime(date) {
            const momentDate = moment(date);

            if (!momentDate.isValid() || empty(date)) {
                return '';
            }

            if (this.$i18n.locale == 'en') {
                return momentDate.format('hh:mm A');
            }

            return momentDate.format('HH:mm');
        },

        /*
         * Object manipulation
         */
        mergeWithoutAdding(a, b) {
            Object.keys(b).forEach(key => {
                // Only update keys that exist in array 'a'
                if (key in a && (typeof a[key] !== 'object' || b[key] !== null)) {
                    if (typeof a[key] === 'object' && typeof b[key] === 'object' && a[key] !== null && b[key] !== null) {
                        a[key] = this.mergeWithoutAdding(a[key], b[key]);
                    } else {
                        a[key] = b[key];
                    }
                }
            });

            return a;
        },


        /*
         * General actions
         */
        hasOption(keypath) {
            if (!this.authUser) return false;

            return has(this.authUser.options, keypath);
        },

        getOption(keypath) {
            if (!this.authUser) return undefined;

            return get(this.authUser.options, keypath);
        },

        phoneIsValid(phone) {
            return !empty(phone.number) &&
                phone.valid &&
                (!phone.validated || phone.type == 'mobile');
        },
    },
};
